import { IInternalUser, ENetworkRequestStatus, EUserType } from 'services/BackendApi';

export interface IInternalUserDomain {
  internalUser: IInternalUser | null;
  assignedDestinations: string[]; // Array of country codes (current selection)
  originalAssignedDestinations: string[]; // Array of country codes (as fetched from server)
  originalUserType: EUserType | null; // Track original type to detect role changes
  request: {
    create: ENetworkRequestStatus;
    get: ENetworkRequestStatus;
    update: ENetworkRequestStatus;
    getAssignedDestinations: ENetworkRequestStatus;
    updateAssignedDestinations: ENetworkRequestStatus;
  };
}

export const initialState: IInternalUserDomain = {
  internalUser: null,
  assignedDestinations: [],
  originalAssignedDestinations: [],
  originalUserType: null,
  request: {
    create: ENetworkRequestStatus.IDLE,
    get: ENetworkRequestStatus.IDLE,
    update: ENetworkRequestStatus.IDLE,
    getAssignedDestinations: ENetworkRequestStatus.IDLE,
    updateAssignedDestinations: ENetworkRequestStatus.IDLE,
  },
};
